import { AppEnvironments } from "constants/app_environments";

const appEnvironment = process.env.REACT_APP_RUM_ENV || AppEnvironments.Development;

export const isProductionEnvironment = (): boolean => {
  return !!process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === "production";
};

export const isProductionFedRampEnvironment = (): boolean => {
  return appEnvironment === AppEnvironments.ProductionFedRAMP;
};

export const isProductionUsEnvironment = (): boolean => {
  return appEnvironment === AppEnvironments.ProductionUs;
};
